/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {Platform} from 'react-native';
import { defaultValues, showErrorValuesDefault, showErrorValuesSubmit } from '../../data/constants/inscription';
import { IError } from '../../data/types/interface/inscription';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultValues);

  const handleChange = (
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    let _value = value;
    if (value === 'INVALID INPUT') {
      setValues({...values, [name]: 'INVALID INPUT'});
    } else {
      if (Platform.OS !== 'web' && (name === 'cin' || name === 'image')) {
        _value = {
          uri: value.uri,
          type: value.type,
          name: value.fileName,
        };
      }

      if (name === 'cin') {
        if (remove) {
          setValues({...values, [name]: _value});
        } else {
          const images = [...values[name]];
          images.push(_value);
          setValues({...values, [name]: images});
        }
      } else {
        setValues({...values, [name]: _value});
      }
    }

    setShowErrors({...showErrors, [name]: value !== fired});
  };

  const noError = () => {
    let bNoError = true;
    Object.entries(errors).forEach((element) => {
      if (element[1] !== '' && element[0] !== 'acceptedCondition') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence));
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
